import { snack } from "components/Snack/Snack";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import AppSmartForm from "components/AppSmartForm/AppSmartForm";
import permissionsSAService from "services/superadmin/permissionsSAService";

const PermissionForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { permission },
}) => {

  const fieldsWithData = [
    {
      key: "name",
      label: "Название",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "resource",
      label: "Модуль",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "action",
      label: "Действия",
      inputType: inputTypeEnum.text
    },
  ]

  const onSubmit = async (formValues) => {
    try {
      if (permission) {
        await permissionsSAService.put(id, formValues)
        snack("Права обновлен успешно!");
      } else {
        await permissionsSAService.post(formValues)
        snack("Права создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={permission ? 'Редактирование прав' : 'Создание прав'}>
      <AppSmartForm onSubmit={onSubmit} data={permission} fields={fieldsWithData}></AppSmartForm>
    </CrudPage>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(PermissionForm, (router) => {
    let requests = {}

    if (router.params.id) {
      requests['permission'] = () => permissionsSAService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
